import { fetchCurrentUserData, customFetch} from "@/util/customFetch";
import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";

export async function getAllEventsForSite(site_id, headers) {
  if (!isOfflineDev) {
    return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/events/getAllEventsBySite?site_id=${site_id}`, {
      method: 'GET',
      headers: headers,
    })
        .then(res => res.json()
            .then(data => { return data })
        )
  }
  else return { status: 200, data: { results: [] }}
}

export async function getAlerts(site_id, headers) {
  if (!isOfflineDev) {
    return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/events/alerts?site_id=${site_id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return { status: 200, data: { results: [] }}
}

export async function getAlertsForSites(siteIds, headers) {
  if (!isOfflineDev) {
    const tokenData = await fetchCurrentUserData();
    const allHeaders = { ...headers, ...tokenData };

    const queryString = siteIds.map(id => `site_id=${encodeURIComponent(id)}`).join('&');

    const response = await fetch(`${BACKEND_API_PLACEHOLDER}/api/v1/events/alerts/multisite?${queryString}`, {
        method: 'GET',
        headers: allHeaders,
      }
    )

    const data = await response.json();
    return data;
  } else {
    return { status: 200, data: { results: [] } };
  }
}


export async function getAlertsToday(site_id){
    return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/events/alerts/today?site_id=${site_id}`, 'GET')
}

export async function getNotificationPreferences(site_id, site_employee_id){
    return customFetch(BACKEND_API_PLACEHOLDER + `/api/alerts/getNotificationPreferences?site_id=${site_id}&site_employee_id=${site_employee_id}`, 'GET')
}


export async function setNotificationPreferences(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/alerts/setNotificationPreferences`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function setPortalNotificationPreferences(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/users/data/updateContactInfo`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function setMultiSitePreferences(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/multi_site/putAlertMultiEdit`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function acknowledgeEvent(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/events/acknowledgeEvent?event_id=${id}`, {
    method: 'GET',
    headers: headers
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function acknowledgeAllEventsBySite(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/events/acknowledgeAllEventsBySite?site_id=${headers.siteId}`, {
    method: 'POST',
    headers: headers
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getAllNotificationTopics(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/getAllNotificationTopics`, {
    method: 'GET',
    headers: headers
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getAllNotificationTopicsBySite(site_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/getAllNotificationTopicsBySite?site_id=${site_id}`, {
    method: 'GET',
    headers: headers
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getTopicSubscriberForUser(user_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/getTopicSubscriberForUser?user_id=${user_id}`, {
    method: 'GET',
    headers: headers
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getAllNotificationTopicSubscribers(site_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/getAllNotificationTopicSubscribers`, {
    method: 'GET',
    headers: headers
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function upsertTopicSubscribers(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/upsertTopicSubscribers`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function createNotificationTopicSubscriber(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/createNotificationTopicSubscriber`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function updateNotificationTopicSubscriber(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/notification_topic/updateNotificationTopicSubscriber`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}